// Para probar en LOCAL no se edita este archivo (así no se escapa un localhost a producción):
// se corre con las variables puestas y listo. Ej.:
//   REACT_APP_API_URL=http://localhost:8000 REACT_APP_AI_URL=http://localhost:8001 npm start
// Sin variables (o sea, en `npm run build`), quedan los valores de PRODUCCIÓN de abajo.

// PROD: backend clínico Laravel
export const apiUrl = process.env.REACT_APP_API_URL || "https://draschofatapi.rocazit.com";
// API del AGENTE de IA (el chat hace POST `${apiAI}/askai`).
// PROD: Supabase Edge Function (Deno) — reemplaza al agente del VPS.
// ROLLBACK: descomentá el VPS (o localhost:8001) y re-buildeá.
// export const apiAI = "https://agent-api.gamobo.shop";   // VPS (rollback)
export const apiAI = process.env.REACT_APP_AI_URL ||
  "https://kwygpzemibjvwljgyvae.supabase.co/functions/v1/drclic-agent";
// Identificador de ESTE frontend/doctor: el agente guarda perfil (nombre, vocabulario,
// preferencias) y memoria de chat separados por doctor. Cambiar en cada front nuevo.
export const doctorId = "pediatria-schofat";
export const drName = "Dra. Schofat Abújder Israel";
export const specificConfigurationDataUrl =
  apiUrl + "/api/v1/configuracion/getdoctor";

//aca se asigna el backend que voy a utilizar.
